module.exports = __webpack_public_path__ + "img/zyjy_09.f0589ff2.png";